import { useState, useEffect } from "react";
import { DocumentTextIcon, TableCellsIcon, ChartBarIcon, CalendarIcon } from "@heroicons/react/24/outline";
import ExportButton, { 
  ExportContactsButton, 
  ExportOpportunitiesButton, 
  ExportActivitiesButton,
  ExportDashboardButton 
} from "../../components/Export/ExportButton";

export default function ReportsPage() {
  const [filters, setFilters] = useState({
    dateRange: "last30days",
    startDate: "",
    endDate: ""
  });

  const getDateFilters = () => {
    if (filters.dateRange === "custom" || filters.startDate || filters.endDate) {
      return {
        start_date: filters.startDate || undefined,
        end_date: filters.endDate || undefined
      };
    }
    return {};
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900">Relatórios e Exportações</h1>
          <p className="mt-1 text-sm text-gray-600">
            Exporte seus dados do CRM em diferentes formatos
          </p>
        </div>

        <div className="bg-white shadow rounded-lg">
          <div className="px-4 py-5 sm:p-6">
            <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">
              Exportações Disponíveis
            </h3>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
              <div className="border rounded-lg p-4">
                <TableCellsIcon className="h-8 w-8 text-blue-600 mb-2" />
                <h4 className="font-medium">Contatos</h4>
                <p className="text-sm text-gray-500 mb-3">Lista completa</p>
                <ExportContactsButton size="sm" />
              </div>
              
              <div className="border rounded-lg p-4">
                <ChartBarIcon className="h-8 w-8 text-green-600 mb-2" />
                <h4 className="font-medium">Oportunidades</h4>
                <p className="text-sm text-gray-500 mb-3">Pipeline de vendas</p>
                <ExportOpportunitiesButton size="sm" />
              </div>
              
              <div className="border rounded-lg p-4">
                <CalendarIcon className="h-8 w-8 text-purple-600 mb-2" />
                <h4 className="font-medium">Atividades</h4>
                <p className="text-sm text-gray-500 mb-3">Relatório completo</p>
                <ExportActivitiesButton size="sm" />
              </div>
              
              <div className="border rounded-lg p-4">
                <DocumentTextIcon className="h-8 w-8 text-orange-600 mb-2" />
                <h4 className="font-medium">Dashboard</h4>
                <p className="text-sm text-gray-500 mb-3">Snapshot PDF</p>
                <ExportDashboardButton size="sm" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
